const FIELD = {
  TYPE: {
    TEXT: 1,
    EMAIL: 2,
    NUMBER: 3,
    PASSWORD: 5,
    DATE: 6,
    CHECKBOX: 7,
    RADIO: 8,
    SELECT: 9,
    HIDDEN: 10,
    TEXTAREA: 11,
    RADIOGROUP: 12,
    CHECKBOXGROUP: 13,
    CHECKOUTINPUT: 14,
    CHECKOUTRADIO: 15,
    CHECKOUTPHONE: 16,
    TELEPHONE: 17,
    OTHER: 99,
  },
  VALIDATIONS: {
    REQUIRED: 1,
    MIN_LENGTH: 2,
    MAX_LENGTH: 3,
    EMAIL: 4,
    PASSWORD: 5,
    CONFIRM_FIELD: 6,
    EXACT_LENGTH: 7,
    ZIPCODE: 8,
    PHONENUMBER: 9,
  },
};

export { FIELD };
